module.exports = __webpack_public_path__ + "img/mobile/BetBar/btn-sound_off@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/btn-sound_off@3x.png
// module id = 604
// module chunks = 0